import React from 'react';
import { IconProps } from '../DefaultIcon';

export function ProcessesIcon({ className }: IconProps) {
  return (
    <svg
      width="80"
      height="80"
      viewBox="0 0 80 80"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g clipPath="url(#clip0_4_2352)">
        <path
          d="M39.8789 80C39.1538 80 38.4287 79.2749 38.4287 78.5499V1.45015C38.4287 0.725076 39.1538 0 39.8789 0C40.6039 0 41.329 0.725076 41.329 1.45015V78.5499C41.329 79.2749 40.8456 80 39.8789 80Z"
          fill="#00C4B3"
        />
        <path
          d="M14.5012 80C14.2596 80 14.0179 80 14.0179 79.7583C13.2928 79.5166 13.0511 78.5499 13.2928 77.8248L38.6704 20.3021C38.9121 19.577 39.8789 19.3353 40.604 19.577C41.329 19.8187 41.5707 20.7855 41.329 21.5106L15.9514 79.0332C15.7097 79.5166 14.9846 80 14.5012 80Z"
          fill="#00C4B3"
        />
        <path
          d="M65.2568 80C64.7734 80 64.0484 79.7583 63.8067 79.0332L38.6707 21.5106C38.429 20.7855 38.6707 19.8187 39.3958 19.577C40.1209 19.3353 41.0876 19.577 41.3293 20.3021L66.707 77.8248C66.9487 78.5499 66.707 79.5166 65.9819 79.7583C65.7402 79.7583 65.4985 80 65.2568 80Z"
          fill="#00C4B3"
        />
        <path
          d="M78.3082 9.1843H1.93359V63.565H78.3082V9.1843Z"
          fill="#EAEEF9"
        />
        <path
          d="M79.2749 5.55891H0.725076C0.241692 5.55891 0 5.80061 0 6.28399V8.45922C0 8.9426 0.241692 9.18429 0.725076 9.18429H79.2749C79.7583 9.18429 80 8.9426 80 8.45922V6.28399C80 5.80061 79.5166 5.55891 79.2749 5.55891Z"
          fill="#00C4B3"
        />
        <path
          d="M79.2749 63.565H0.725076C0.241692 63.565 0 63.8067 0 64.29V66.4653C0 66.9486 0.241692 67.1903 0.725076 67.1903H79.2749C79.7583 67.1903 80 66.9486 80 66.4653V64.29C80 63.8067 79.5166 63.565 79.2749 63.565Z"
          fill="#00C4B3"
        />
        <path
          d="M47.1301 58.006V16.1933C47.1301 15.4683 46.4051 15.2266 45.9217 15.71L37.4625 24.4109C37.2208 24.6526 36.7374 24.8943 36.254 24.6526L30.9368 22.2356C30.4534 21.994 29.97 22.2356 29.7283 22.4773L22.7193 29.4864C22.4776 29.7281 21.7525 29.9698 21.5108 29.7281L16.9187 27.0695C16.4353 26.8278 15.9519 26.8278 15.4685 27.3112L7.25098 36.4955V58.2477H47.1301V58.006Z"
          fill="#EAEEF9"
        />
        <path
          d="M36.9791 39.6375L30.9368 36.4955C30.4534 36.2538 29.97 36.4955 29.4866 36.7372L21.9942 45.6798C21.7525 46.1631 21.0274 46.1631 20.544 45.9215L15.4685 43.5045C15.2268 43.2628 14.5017 43.5045 14.26 43.7462L7.25098 50.7553V58.006H50.7555V28.5196C50.7555 27.7946 50.0304 27.5529 49.5471 28.0363L38.1875 39.3958C37.7042 39.8792 37.2208 39.8792 36.9791 39.6375Z"
          fill="#00C4B3"
        />
        <path
          d="M25.1355 45.9215C25.1355 47.855 23.4437 49.5468 21.5101 49.5468C19.5766 49.5468 17.8848 47.855 17.8848 45.9215C17.8848 43.9879 19.5766 42.2961 21.5101 42.2961C23.4437 42.2961 25.1355 43.9879 25.1355 45.9215Z"
          fill="#FBFCFE"
        />
        <path
          d="M33.5955 21.994C33.5955 23.9275 31.9036 25.6193 29.9701 25.6193C28.0366 25.6193 26.3447 23.9275 26.3447 21.994C26.3447 20.0604 28.0366 18.3686 29.9701 18.3686C31.9036 18.3686 33.5955 20.0604 33.5955 21.994Z"
          fill="#00416B"
        />
        <path
          d="M41.3289 39.3958C41.3289 41.3293 39.637 43.0211 37.7035 43.0211C35.77 43.0211 34.0781 41.3293 34.0781 39.3958C34.0781 37.4622 35.77 35.7704 37.7035 35.7704C39.637 35.7704 41.3289 37.4622 41.3289 39.3958Z"
          fill="#FBFCFE"
        />
        <path
          d="M23.6854 45.9215C23.6854 47.1299 22.7186 48.0967 21.5102 48.0967C20.3017 48.0967 19.335 47.1299 19.335 45.9215C19.335 44.713 20.3017 43.7462 21.5102 43.7462C22.7186 43.7462 23.6854 44.713 23.6854 45.9215Z"
          fill="#00416B"
        />
        <path
          d="M32.1454 21.994C32.1454 23.2024 31.1786 24.1692 29.9701 24.1692C28.7617 24.1692 27.7949 23.2024 27.7949 21.994C27.7949 20.7855 28.7617 19.8187 29.9701 19.8187C31.1786 19.8187 32.1454 20.7855 32.1454 21.994Z"
          fill="#00C4B3"
        />
        <path
          d="M39.8788 39.3958C39.8788 40.6042 38.912 41.571 37.7035 41.571C36.4951 41.571 35.5283 40.6042 35.5283 39.3958C35.5283 38.1873 36.4951 37.2206 37.7035 37.2206C38.6703 37.2206 39.8788 38.1873 39.8788 39.3958Z"
          fill="#00416B"
        />
        <path
          d="M22.2353 48.8217H20.7852V58.006H22.2353V48.8217Z"
          fill="#FBFCFE"
        />
        <path
          d="M30.6953 24.8943H29.2451V58.006H30.6953V24.8943Z"
          fill="#00416B"
        />
        <path
          d="M38.1875 42.2961H36.7373V58.2477H38.1875V42.2961Z"
          fill="#FBFCFE"
        />
        <path
          d="M50.755 58.7311H7.25047C6.76708 58.7311 6.52539 58.4894 6.52539 58.006V14.5015C6.52539 14.0181 6.76708 13.7764 7.25047 13.7764C7.73385 13.7764 7.97554 14.0181 7.97554 14.5015V57.281H50.755C51.2384 57.281 51.4801 57.5227 51.4801 58.006C51.4801 58.4894 51.2384 58.7311 50.755 58.7311Z"
          fill="#00416B"
        />
        <path
          d="M9.42569 51.4804H7.25047C6.76708 51.4804 6.52539 51.2387 6.52539 50.7553C6.52539 50.2719 6.76708 50.0302 7.25047 50.0302H9.42569C9.90908 50.0302 10.1508 50.2719 10.1508 50.7553C10.1508 51.2387 9.90908 51.4804 9.42569 51.4804Z"
          fill="#00416B"
        />
        <path
          d="M9.42569 44.2296H7.25047C6.76708 44.2296 6.52539 43.9879 6.52539 43.5045C6.52539 43.0212 6.76708 42.7795 7.25047 42.7795H9.42569C9.90908 42.7795 10.1508 43.0212 10.1508 43.5045C10.1508 43.9879 9.90908 44.2296 9.42569 44.2296Z"
          fill="#00416B"
        />
        <path
          d="M9.42569 36.9789H7.25047C6.76708 36.9789 6.52539 36.7372 6.52539 36.2538C6.52539 35.7704 6.76708 35.5287 7.25047 35.5287H9.42569C9.90908 35.5287 10.1508 35.7704 10.1508 36.2538C10.1508 36.7372 9.90908 36.9789 9.42569 36.9789Z"
          fill="#00416B"
        />
        <path
          d="M9.42569 29.7281H7.25047C6.76708 29.7281 6.52539 29.4864 6.52539 29.003C6.52539 28.5196 6.76708 28.278 7.25047 28.278H9.42569C9.90908 28.278 10.1508 28.5196 10.1508 29.003C10.1508 29.4864 9.90908 29.7281 9.42569 29.7281Z"
          fill="#00416B"
        />
        <path
          d="M9.42569 22.4773H7.25047C6.76708 22.4773 6.52539 22.2357 6.52539 21.7523C6.52539 21.2689 6.76708 21.0272 7.25047 21.0272H9.42569C9.90908 21.0272 10.1508 21.2689 10.1508 21.7523C10.1508 22.2357 9.90908 22.4773 9.42569 22.4773Z"
          fill="#00416B"
        />
        <path
          d="M9.42569 15.2266H7.25047C6.76708 15.2266 6.52539 14.9849 6.52539 14.5015C6.52539 14.0181 6.76708 13.7764 7.25047 13.7764H9.42569C9.90908 13.7764 10.1508 14.0181 10.1508 14.5015C10.1508 14.9849 9.90908 15.2266 9.42569 15.2266Z"
          fill="#00416B"
        />
        <path
          d="M63.975 29.5C63.8 31.35 62.775 33.325 61 34.15V36.2C62.025 36.125 63.45 35.55 63.975 34.925V47H67.1V29.5H63.975Z"
          fill="#16406A"
        />
      </g>
      <defs>
        <clipPath id="clip0_4_2352">
          <rect width="80" height="80" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
